import { useState } from 'react';
import { motion } from 'framer-motion';
import bigChillImg from '../../assests/Big Chill.png';
import contactsIcon from '../../assests/contacts.png';

interface ContactLink {
  id: string;
  label: string;
  value: string;
  href: string;
  icon: JSX.Element;
}

const contactLinks: ContactLink[] = [
  {
    id: 'github',
    label: 'Github',
    value: 'MDTOUFIQUE623',
    href: 'https://github.com/MDTOUFIQUE623',
    icon: (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z" />
      </svg>
    ),
  },
  {
    id: 'linkedin',
    label: 'LinkedIn',
    value: 'MD Toufique',
    href: 'https://www.linkedin.com/in/md-toufique-047352375/',
    icon: (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
      </svg>
    ),
  },
  {
    id: 'gmail',
    label: 'Email',
    value: 'ahmedtoufiqkhan37@gmail.com',
    href: 'mailto:ahmedtoufiqkhan37@gmail.com',
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
      </svg>
    ),
  },
  {
    id: 'phone',
    label: 'Phone',
    value: '+91 9407716623',
    href: 'tel:+919407716623',
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
      </svg>
    ),
  },
  {
    id: 'location',
    label: 'Location',
    value: 'Bangalore, India',
    href: 'https://maps.google.com/?q=Bangalore,India',
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    ),
  },
];

export default function Contact() {
  const [hoveredId, setHoveredId] = useState<string | null>(null);

  return (
    <section id="contact" className="py-24 md:py-32 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16">
        {/* Section header */}
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="flex items-center gap-3 mb-10"
        >
          <img src={contactsIcon} alt="" className="w-8 h-8 object-contain" />
          <h2
            className="text-white font-bold section-label"
            style={{ fontSize: 'clamp(1.8rem, 4vw, 3rem)', letterSpacing: '0.05em' }}
          >
            Contact
          </h2>
        </motion.div>

        {/* Main Grid container */}
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_400px] gap-8 relative z-10">
          
          {/* Left Column — Glassmorphic Interface for Links */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="p-8 sm:p-10 rounded-3xl bg-black/40 backdrop-blur-xl border border-[#00B92E]/20 shadow-[0_0_50px_rgba(0,185,46,0.05)] relative overflow-hidden"
          >
            {/* Background glow effects inside panel */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-[#00B92E]/10 rounded-full blur-[100px] -translate-y-1/2 translate-x-1/2 pointer-events-none" />
            
            <div className="mb-10">
              <h3 className="text-2xl font-bold text-white mb-3" style={{ fontFamily: 'Orbitron, sans-serif' }}>
                Let's Initiate Contact.
              </h3>
              <p className="text-white/60 leading-relaxed text-sm max-w-xl">
                I am actively seeking opportunities in AI Engineering, Machine Learning, and Full Stack Development.
                Whether you have a question or just want to say hi, I'll try my best to get back to you!
              </p>
            </div>

            {/* The Links as beautiful list rows */}
            <div className="flex flex-col gap-4">
              {contactLinks.map((link, i) => (
                <motion.a
                  key={link.id}
                  href={link.href}
                  target={link.id !== 'phone' ? '_blank' : undefined}
                  rel="noopener noreferrer"
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: 0.2 + i * 0.1 }}
                  onMouseEnter={() => setHoveredId(link.id)}
                  onMouseLeave={() => setHoveredId(null)}
                  className="group relative flex items-center gap-6 p-5 rounded-2xl bg-white/[0.02] border border-white/[0.05] hover:border-[#00B92E]/50 transition-all duration-300 hover:bg-[#00B92E]/5 overflow-hidden"
                >
                  {/* Subtle hover gradient sweep */}
                  <div 
                    className="absolute inset-0 bg-gradient-to-r from-transparent via-[#00B92E]/10 to-transparent -translate-x-[100%] group-hover:translate-x-[100%] transition-transform duration-1000 ease-in-out pointer-events-none" 
                  />

                  {/* Icon Container */}
                  <div 
                    className="flex-shrink-0 w-14 h-14 flex items-center justify-center rounded-full bg-black/50 border transition-all duration-300"
                    style={{ 
                      borderColor: hoveredId === link.id ? '#00B92E' : 'rgba(255,255,255,0.1)',
                      color: hoveredId === link.id ? '#00B92E' : 'white',
                      boxShadow: hoveredId === link.id ? '0 0 20px rgba(0,185,46,0.3)' : 'none'
                    }}
                  >
                    {link.icon}
                  </div>

                  {/* Text Container */}
                  <div className="flex-1 min-w-0">
                    <p className="text-white/40 text-xs font-semibold tracking-widest uppercase mb-1">
                      {link.label}
                    </p>
                    <p 
                      className="text-white text-lg font-medium truncate transition-colors duration-300"
                      style={{ color: hoveredId === link.id ? '#00B92E' : 'white' }}
                    >
                      {link.value}
                    </p>
                  </div>

                  {/* Arrow Indicator */}
                  <div className="flex-shrink-0 text-white/20 group-hover:text-[#00B92E] group-hover:translate-x-1 transition-all duration-300">
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </div>
                </motion.a>
              ))}
            </div>
          </motion.div>

          {/* Right — Big Chill alien */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="hidden lg:flex justify-end items-end"
          >
            <div className="relative">
              <div
                className="absolute inset-0 pointer-events-none"
                style={{
                  background:
                    'radial-gradient(ellipse 60% 80% at 50% 60%, rgba(0,150,255,0.06) 0%, transparent 70%)',
                  filter: 'blur(30px)',
                  transform: 'scale(1.4)',
                }}
              />
              <motion.img
                src={bigChillImg}
                alt="Big Chill"
                className="relative w-[280px] xl:w-[340px] object-contain"
                animate={{ y: [0, -12, 0] }}
                transition={{ duration: 4, repeat: Infinity, ease: 'easeInOut' }}
              />
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
}
